import React from "react";
import { Row, Col, Image } from "react-bootstrap";
import "./index.scss";
import produitImg from "../../../assets/images/o1.png";

const UtilisationSection = ({ product, id }) => {
  let steps = [];

  // Debug: Log the product data
  console.log("UtilisationSection - product:", product);
  console.log("UtilisationSection - utilisation:", product?.utilisation);

  // Process utilisation data
  if (product?.utilisation) {
    console.log("Raw utilisation data:", product.utilisation);
    console.log("Type:", typeof product.utilisation);
    console.log("Is Array:", Array.isArray(product.utilisation));
    
    let utilisationArray = [];
    
    if (Array.isArray(product.utilisation)) {
      // Check if it's an array containing a single JSON string
      if (product.utilisation.length === 1 && typeof product.utilisation[0] === 'string') {
        const firstItem = product.utilisation[0];
        console.log("Single string item:", firstItem);
        
        // Check if it's a JSON array string
        if (firstItem.startsWith('[') && firstItem.endsWith(']')) {
          try {
            const parsed = JSON.parse(firstItem);
            console.log("Parsed JSON array:", parsed);
            if (Array.isArray(parsed)) {
              utilisationArray = parsed;
            } else {
              // If parsing fails, treat as comma-separated string
              utilisationArray = firstItem.split(',').map(item => item.trim());
            }
          } catch (e) {
            console.log("JSON parse failed, treating as comma-separated");
            // If parsing fails, treat as comma-separated string
            utilisationArray = firstItem.split(',').map(item => item.trim());
          }
        } else {
          // Regular string, split by comma
          utilisationArray = firstItem.split(',').map(item => item.trim());
        }
      } else {
        // Normal array with multiple items
        utilisationArray = product.utilisation;
      }
    } else if (typeof product.utilisation === 'string') {
      // If it's a string, try to parse it or split it
      try {
        const parsed = JSON.parse(product.utilisation);
        if (Array.isArray(parsed)) {
          utilisationArray = parsed;
        } else {
          // If not a JSON array, split by comma
          utilisationArray = product.utilisation.split(',').map(item => item.trim());
        }
      } catch (e) {
        // If JSON parsing fails, split by comma
        utilisationArray = product.utilisation.split(',').map(item => item.trim());
      }
    }
    
    console.log("Processed utilisation array:", utilisationArray);
    
    if (utilisationArray.length > 0) {
      // transformer chaque step en objet { number, text }
      steps = utilisationArray.map((text, index) => {
        console.log(`Step ${index + 1}:`, text);
        return {
          number: (index + 1).toString().padStart(2, "0"),
          text: text.trim(),
        };
      });
      console.log("Final steps array:", steps);
    } else {
      console.log("No utilisation data found, using fallback");
      steps = [{ number: "01", text: "Aucune information d'utilisation disponible" }];
    }
  } else {
    console.log("No utilisation data found, using fallback");
    steps = [{ number: "01", text: "Aucune information d'utilisation disponible" }];
  }

  // Découpage en 2 colonnes si steps > 5
  let col1 = [];
  let col2 = [];
  if (steps.length > 5) {
    const mid = Math.ceil(steps.length / 2);
    col1 = steps.slice(0, mid);
    col2 = steps.slice(mid);
  } else {
    col1 = steps;
  }

  const renderSteps = (stepsArray) =>
    stepsArray.map((step, index) => (
      <div key={index} className="step d-flex mb-4">
        <div className="step-number">{step.number}</div>
        <div className="step-text">{step.text}</div>
      </div>
    ));

  return (
    <div className="utilisation-section py-5">
      <Row className=" mx-0 gx-0 px-0">
        <Col md={4} className="image-col">
          <Image
            src={`https://api.almasecret.msit-demo.fr/products/${id}/image/image`}
            alt="Produit"
            className="w-100"
          />
        </Col>

        {/* Colonnes de steps */}
        <Col md={col2.length ? 4 : 4} className="text-col">
          <h2 className="section-title ps-4">UTILISATION</h2>
          <div className="steps ps-4">{renderSteps(col1)}</div>
        </Col>

        {col2.length > 0 && (
          <Col md={4} className="text-col">
            <div className="steps ps-4">{renderSteps(col2)}</div>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default UtilisationSection;
